import { LOADING_STATUS } from '../../../shared/constants/loadingStatus';

// Cards need the tenant's language set to decide whether to draw a language flag. That comes
// from tenant settings, which resolves well after the list does because it fans out to the
// upstream WayThru platform, so without this gate the grid renders first and grows flags
// later. A failed fetch must not block the page — the flag is dropped instead.
function isTenantSettingsPending(tenantSettingsStatus) {
  return (
    tenantSettingsStatus === LOADING_STATUS.IDLE || tenantSettingsStatus === LOADING_STATUS.LOADING
  );
}

export function getIsTemplatesInitialLoading({
  apiReady,
  hasLoadedOnce,
  isSearchActive,
  itemsLength,
  listStatus,
  tenantSettingsStatus,
}) {
  if (!apiReady) return true;
  if (isTenantSettingsPending(tenantSettingsStatus)) return true;
  return (
    !hasLoadedOnce &&
    !isSearchActive &&
    itemsLength === 0 &&
    (listStatus === LOADING_STATUS.IDLE || listStatus === LOADING_STATUS.LOADING)
  );
}
